import {
  Card,
  CardMedia,
  Typography,
  CardContent,
  CardActionArea,
} from '@mui/material';

export default function Cards(props) {
  return (
    <Card
      sx={{
        maxWidth: 300,
        marginBottom: 2,
        border: '1px solid rgba(140, 199, 247, 0.4)',
        padding: 0,
        cursor: 'pointer',
      }}
      onClick={props.link}>
      <CardActionArea>
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 300,
            flexDirection: 'column',
          }}>
          <CardMedia
            component="img"
            sx={{
              width: 70,
              height: 70,
              objectFit: 'contain',
            }}
            image={props.image}
            alt="cockpit_icons"
          />

          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {props.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {props.description}
            </Typography>
          </CardContent>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
